import { render } from "./CTAItem.vue?vue&type=template&id=12495328&scoped=true"
import script from "./CTAItem.vue?vue&type=script&lang=js"
export * from "./CTAItem.vue?vue&type=script&lang=js"

import "./CTAItem.vue?vue&type=style&index=0&id=12495328&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12495328"]])

export default __exports__